import { useTranslation } from 'react-i18next';
import { MdExpandMore } from 'react-icons/md';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { Card, CardContent, CardTitle } from '@client/toolkit';
import { getColors } from '../../../../../styles/color-tokens';
import { AuditTable } from './audit-table';

export function AgreementAuditTrailCard() {
  const colors = getColors();
  const { t } = useTranslation('agreements');
  return (
    <Card>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<MdExpandMore className="text-white" />}
          aria-controls="audit-trail-content"
          id="audit-trail-header"
          sx={{
            color: colors.text.primary,
            backgroundColor: colors.background.surface.base,
          }}
        >
          <CardTitle className="flex-1" variant="highlighted">
            {t('auditTrail.title')}
          </CardTitle>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: colors.background.surface.base,
          }}
        >
          <CardContent variant="fill" className="mx-4 mb-6 justify-self-center border border-border rounded-lg w-full">
            <AuditTable />
          </CardContent>
        </AccordionDetails>
      </Accordion>
    </Card>
  );
}
